









































































import { Component } from 'vue-property-decorator';
import CardFormElement from '@/components/cards/CardFormElement.vue';
import draggable from 'vuedraggable';
import Editor from '@/components/Editor.vue';
import ElementBase from './ElementBase';

@Component({
    name: 'ElementInputOptions',
    components: {
        'editor': Editor,
        draggable,
        'card-form-element': CardFormElement,
    },
})
export default class ElementInputOptions extends ElementBase {
    addOption() {
        const id = this.input.options ? this.input.options.length : 0;
        const option: any = {
            id,
            label: '',
            points: 0,
            collapsed: false,
            description: '',
        };

        if (this.input.options) {
            this.input.options.push(option);
        } else {
            this.input.options = [option];
        }
    }

    removeOption(option: any) {
        if (this.input.options) {
            const index = this.input.options.indexOf(option);

            this.input.options.splice(index, 1);
        }
    }
}
